import { render, staticRenderFns } from "./TeyaCallback.vue?vue&type=template&id=6ba4b0d0&scoped=true"
import script from "./TeyaCallback.vue?vue&type=script&lang=js"
export * from "./TeyaCallback.vue?vue&type=script&lang=js"
import style0 from "./TeyaCallback.vue?vue&type=style&index=0&id=6ba4b0d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba4b0d0",
  null
  
)

export default component.exports